import React from 'react';
import { DragSource } from 'react-dnd';
import { connect } from 'react-redux';

const dNdSpecificationMethods = {
    beginDrag(props) {
        return props;
    },
};

// Make these methods accesible to the component
const collect = (connectDnD, monitor) => (
    {
        connectDragSource: connectDnD.dragSource(),
        isDragging: monitor.isDragging(),
        connectDragPreview: connectDnD.dragPreview(),
    }
);

const SideBarComponent = (props) => {
    const { isDragging, connectDragSource, connectDragPreview } = props;
    const opacity = isDragging ? 0.4 : 1;

    return connectDragPreview(
        <button className="drag-component draggable" style={{ opacity }}>
            {connectDragSource(<div className="drag-handle" />)}
            {props.component}
        </button>,
    );
};

export default connect()(DragSource(
    'SideBarComponent',
    dNdSpecificationMethods,
    collect,
)(SideBarComponent));
